






































import { Component, Prop, Vue } from 'nuxt-property-decorator'
import {
  computed,
  defineComponent,
  ref,
  useRoute,
  useStore,
  onMounted,
} from '@nuxtjs/composition-api'
import { useColoredTitle } from '@/composition/coloredTitle'
import BlockVacancyFilters from '@/components/BlockVacancyFilters.vue'
import BlockBreadCrumbs from '@/components/BlockBreadCrumbs.vue'
import BlockVacancyList from '@/components/BlockVacancyList.vue'

@Component
class SectionSearchVacancy extends Vue {
  @Prop() readonly sectionDataLocal: object = {}
  @Prop() readonly searchError: boolean = false
  @Prop() readonly listSpecialties: ReadonlyArray<any> = []
  @Prop() readonly listRegions: ReadonlyArray<any> = []
  @Prop() readonly initialListVacancies: ReadonlyArray<any> = []
  @Prop({ default: 0 }) readonly initialTotalCountVacancies: number = 0

  static options: any
}

export default defineComponent({
  name: 'SectionSearchVacancy',
  components: {
    BlockVacancyList,
    BlockVacancyFilters,
    BlockBreadCrumbs,
  },
  props: SectionSearchVacancy.options.props,
  setup(props: SectionSearchVacancy) {
    const store = useStore()

    // При монтировании проверяем, если есть вакансии, то берем дату первого элемента
    onMounted(() => {
      if (props.initialListVacancies && props.initialListVacancies.length) {
        // Например, используем поле createdAt; если есть updatedAt, можно заменить на него
        const vacancyDate = props.initialListVacancies[0].createdAt
        // Отправляем дату в стор через мутацию
        store.commit('settings/SET_UPDATED_TIME', vacancyDate)
      }
    })

    const searchLoading = ref(false)
    const { coloredTitle } = useColoredTitle(
      props.sectionDataLocal.titleFilters
    )
    const { getters } = useStore()
    const {
      value: {
        query: { search, speciality, region },
      },
    } = useRoute()
    const buttonText = computed(() => getters['settings/btnLoadMore'])
    const searchErrorText =
      'Что-то пошло не так при загрузке результатов поиска. Попробуйте обновить страницу или зайти позже'
    const blockFiltersData = ref({
      noResultTextSelect: 'К сожалению, ничего не найдено',
      inputSelectData: {
        labelInputSelect: 'Выберите специализацию',
        placeholderInputSelect: 'например, Дизайн',
      },
      inputRegionData: {
        labelInputSelect: 'Выберите регион',
        placeholderInputSelect: 'например, Москва',
      },
      inputTextData: {
        labelInputText: 'Название должности или ключевые слова',
        placeholderInputText: 'например, бухгалтер',
      },
    })
    const filters = ref({
      search,
      speciality,
      region,
    })

    const changeRegionHandle = (value: string) => {
      filters.value = { ...filters.value, region: value }
    }

    const changeSpecialityHandle = (value: string) => {
      filters.value = { ...filters.value, speciality: value }
    }

    const changeSearchHandle = (value: string) => {
      filters.value = { ...filters.value, search: value }
    }

    return {
      blockFiltersData,
      buttonText,
      filters,
      coloredTitle,
      searchLoading,
      searchErrorText,
      changeSearchHandle,
      changeSpecialityHandle,
      changeRegionHandle,
    }
  },
})
